import React, { useCallback, useState } from "react";
import { SurveyQuestionModel } from "../../models/SurveyQuestionModel";
import { getCollection, setDocument } from "../../core/firebase/firebaseFirestore";
import { QueryDocumentSnapshot } from "firebase/firestore";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const questionsCollectionName = 'questions';

const Questions = () => {

    const [questionFormValue, setQuestionFormValue] = useState<SurveyQuestionModel>({ index: 0, text: '' });
    const queryClient = useQueryClient();

    const { data: questionsArray } = useQuery({
        queryKey: ['questionsData'],
        queryFn: () => getQuestions()
    });

    const onSaveQuestions = useCallback(async (questionsArray: SurveyQuestionModel[]) => {
        await setDocument('list', questionsCollectionName, { list: questionsArray });
    }, []);

    const saveQuestions = useMutation({
        mutationFn: onSaveQuestions,
        onSuccess: () => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ['questionsData'] });
        }
    });

    const getQuestions = useCallback(async () => {
        const response = await getCollection(questionsCollectionName);
        const questions = mapQuestions(response?.docs);
        return questions;
    }, []);

    const mapQuestions = (firebaseSnapshots: QueryDocumentSnapshot[] | undefined) => {
        if (firebaseSnapshots) {
            const list = firebaseSnapshots[0].data().list;
            return list;
        }
        return [];
    }

    const editQuestion = async () => {
        const modifiedArray = questionsArray?.map((question: SurveyQuestionModel) => {
            if (questionFormValue.index === question.index) {
                return questionFormValue;
            }
            return question;
        });
        saveQuestions.mutate(modifiedArray);
        // saveQuestions(modifiedArray);
    }

    const printData = () => (questionsArray?.map((question: SurveyQuestionModel) => {
        return (
            <tr key={question.index}>
                <th scope="row">{question.index}</th>
                <td>{question.text}</td>
                <td>
                    <button className="btn btn-custom" onClick={() => setQuestionFormValue(question)}>Editar</button>
                </td>
            </tr>
        );
    }));

    return (
        <div className="table-wrapper table-responsive">
            <div className="row d-flex align-item-center">
                {/* <div className="col-12">
                    <button className="btn btn-custom" onClick={() => saveQuestions(getQuestionsArray())}>Guardar preguntas</button>
                </div> */}
                <div className="col-10">
                    <label htmlFor="questionForm" className="form-label">Pregunta</label>
                    <input value={questionFormValue.text} onChange={(event) => setQuestionFormValue({ ...questionFormValue, text: event.target.value })} type="text" className="form-control" id="questionForm" placeholder="Ingresar pregunta..." />
                </div>
                <div className="col">
                    <button className="btn btn-custom" onClick={() => editQuestion()}>Guardar</button>
                </div>
            </div>
            <table className="table text-center table-striped table-hover">
                <thead>
                    <tr>
                        <th scope="col">Número</th>
                        <th scope="col">Pregunta</th>
                        <th scope="col">Opciones</th>
                    </tr>
                </thead>
                <tbody>
                    {printData()}
                </tbody>
            </table>
        </div>
    )
}

export default Questions;